// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';

/**
 * Return terms and fees link if specified by query and it exists
 */
export default (req, marketplaceProduct) => {
  const shouldUseLink =
    get(req, 'query.destination_url_field') === 'terms_and_fees_link';
  const link = get(marketplaceProduct, 'supplemental_data.terms_and_fees_link');
  if (shouldUseLink && link) {
    return link;
  }
  return null;
};
